<template>
  <!-- TODO need to add info block in the end -->
  <div class="space-y-24">
    <DsaBlock v-if="isFeatureEnabled('isDsaEnabled')" />

    <div class="flex flex-col gap-24 md:flex-row">
      <BankingDetails v-if="profileMetadata?.useBankingInformationForm" />

      <Overview
        :is-missing-legal-details="!!profileMetadata?.isMissingLegalDetails"
        :legal-details-metadata
      />
    </div>

    <TaxDetails v-if="isVatEnabled" :profile-metadata />

    <EprDetails v-if="isEprEnabled" :legal-details-metadata />

    <TaxResidenceCountry
      v-if="isDac7FeatureEnabled"
      :tax-residence-country-options="
        legalDetailsMetadata?.taxResidenceCountries
      "
    />

    <TaxIdentificationNumber
      v-if="isDac7FeatureEnabled"
      :tax-identification-number-country-options="
        legalDetailsMetadata?.taxIdentityNumberCountries ?? []
      "
    />

    <LegalDocuments
      :is-missing-legal-documents="!!profileMetadata?.isMissingLegalDocuments"
    />
  </div>

  <ModalOnboarding
    :button-label="i18n(translations.onboardingModalButtonLabel)"
    :title="i18n(translations.onboardingModalTitle)"
  >
    <template #description>
      {{ i18n(translations.onboardingModalDescription) }}
    </template>
    <template #to-do>
      {{ i18n(translations.onboardingModalToDoSection) }}
    </template>
    <template #done>
      {{ i18n(translations.onboardingModalDoneSection) }}
    </template>
  </ModalOnboarding>
</template>

<script setup lang="ts">
import { type Error, getApiErrorMessage } from '#imports'
import { computed } from 'vue'

import { sellerProfileAPI } from '@backmarket/http-api'
import { useHttpLazyFetch } from '@backmarket/nuxt-module-http/useHttpLazyFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './LegalDetails.translations'
import BankingDetails from './components/BankingDetails/BankingDetails.vue'
import DsaBlock from './components/DsaBlock/DsaBlock.vue'
import EprDetails from './components/EprDetails/EprDetails.vue'
import LegalDocuments from './components/LegalDocuments/LegalDocuments.vue'
import Overview from './components/Overview/Overview.vue'
import TaxDetails from './components/TaxDetails/TaxDetails.vue'
import TaxIdentificationNumber from './components/TaxIdentificationNumber/TaxIdentificationNumber.vue'
import TaxResidenceCountry from './components/TaxResidenceCountry/TaxResidenceCountry.vue'

const i18n = useI18n()
const { openErrorToast } = useTheToast()
const { isFeatureEnabled } = useBusinessFeaturesStore()

const [
  { data: profileMetadata, error: profileMetadataError },
  { data: legalDetailsMetadata, error: legalDetailsMetadataError },
] = await Promise.all([
  useHttpLazyFetch(sellerProfileAPI.getProfileMetadata),
  useHttpLazyFetch(sellerProfileAPI.getLegalDetailsMetadata),
])

const error = computed(
  () => profileMetadataError.value || legalDetailsMetadataError.value,
)

if (error.value) {
  openErrorToast({
    content: getApiErrorMessage(error.value as unknown as Error),
  })
}

const isVatEnabled = isFeatureEnabled('vatEnabled')
const isEprEnabled = isFeatureEnabled('eprEnabled')
const isDac7FeatureEnabled = isFeatureEnabled('dac7Enabled')
</script>
